import { WeightGridVO } from '../../vo/integration/weightgrid.vo';
import { Model } from "../../model/model";
import { WeightGridEngine as BaseWeightGridEngine, EM_ACTION } from '@wizeoo/akm-compute-lib';
import { cloneDeep } from 'lodash-es';
import { BusinessException, EntityModificationPack } from '@wizeoo/akm-message-lib';
import { EMEngine } from '../entities/entity-modification.engine';
import { CommitCmd } from '../../command/em/commit.cmd';
import { ViewData } from '../../model/view.data';
import { WIZ_COMMAND_STATE } from '@wizeoo/akm-core-lib';
import { WizIcon, WizPopUp } from '@wizeoo/akm-component-lib';

/**
 * Manager de grilles de poids pour le moteur
 */
export class WeightGridEngine extends BaseWeightGridEngine {

  constructor(model: Model) {
    super(model);
  }

  public get model(): Model {
    return this._model as Model;
  }

  public getWeightGridMap(): Map<string, WeightGridVO> {
    return this.model.weightGridMap ? this.model.weightGridMap as Map<string, WeightGridVO> : null;
  }
  public setWeightGridMap(value: Map<string, WeightGridVO>) {
    this.model.weightGridMap = value;
  }

  /** 
   * retourne les WGs, sous forme de []
   * @override
   * @returns 
   */
  public getWeightGrids(): WeightGridVO[] {
    if (this.getWeightGridMap()) {
        return [...this.getWeightGridMap().values()];
    }
    return null;
  }

  /**
   * Récupération d'un weightGrid par code
   * @param pCode Le code du wg recherché
   */
  public getWeightGrid(pCode: string): WeightGridVO {
    return this.getWeightGridMap()?.get(pCode) || null;
  }

  /** création d'une nouvelle wg */
  public buildFakeWG(): WeightGridVO {
      const result: WeightGridVO = new WeightGridVO(this.model);
      result.domain = this.model.domainCode;
      result.businessUnitCode = this.model.businessUnitCode;
      result.visionCode = this.model.visionCode;
      return result;
  }


  /**
   * Clone d'une wg pour édition
   * @param wg la wgVO à cloner
   * @return wgVO,  Un clone
   */
  public cloneWG(wg: WeightGridVO): WeightGridVO {
      const clone = new WeightGridVO(this.model, cloneDeep(wg.source));
      return clone;
  }

  /**
* create/ update d'une wg
* @param to le clone en cours de modif
* @param from l'objet d'origine, inaltéré
* @param callback retour dans la vue
*/
  public mergeWG(to: WeightGridVO, from: WeightGridVO, callback: Function): void {
      let pack: EntityModificationPack;
      if (to.exist) {
          pack = EMEngine.mergeEM(to, from);
      } else {
          pack = EMEngine.createEM(to);
      }

      if (pack && pack.ems.length > 0) {
          // a minima une modif, sinon, c'est le même objet (update)
          new CommitCmd(this.model).commit(pack, this.backFromCallWG.bind(this), [to], callback).execute();
      } else {
          // modèle, le clone est une copie de la valeur d'origine
          ViewData.wizUpdateModel = false;
          callback(to, WIZ_COMMAND_STATE.SUCCESS); // retour en vue
      }
  }

  /**
   * gestion unifiée des retours de service CUD
   * @param cmd la commande commit qui porte les EMs et les objets
   */
  private backFromCallWG(cmd: CommitCmd): void {
      // modèle OK (rollback en cas d'erreur)
      ViewData.wizUpdateModel = false;

      // erreur physique
      if (cmd.state === WIZ_COMMAND_STATE.FAULT) {
          // WizPopUp.toast('$.common.toast.service.error.$', WizIcon.TOAST_ERROR).show();
      } else {
          // le VO source
          const vo: WeightGridVO = cmd.sourceVO[0] as WeightGridVO;
          // une seule modification à la fois, packEntry donne l'objet
          const source: any = cmd.result.entries[0].entity;
          // l'action (un seul type)
          const operation: string = cmd.result.ems[0].operation;
          // la liste d'erreurs métier
          const errors: BusinessException[] = cmd.result.errors;
          // le statut du pack
          const packStatus: string = cmd.result.status;

          if (packStatus === WIZ_COMMAND_STATE.FAULT) {
              errors.forEach((be: BusinessException) => {
                  WizPopUp.toast(be.message, WizIcon.TOAST_ERROR).show();
              });
          } else {
              switch (operation) {
                  case EM_ACTION.UPDATE:
                      vo.source = source; // le clone
                      const sourceWG: WeightGridVO = this.model.weightGridEngine.getWeightGrid(
                          vo.code
                      );
                      if (sourceWG) {
                          sourceWG.source = source;
                      }
                      break;
                  case EM_ACTION.CREATE:
                      vo.source = source;
                      break;
                  case EM_ACTION.DELETE:
                    break;
              }
          }
          cmd.viewCallBack(vo, packStatus); // retour en vue
      }
  }


}
